export default __webpack_public_path__ + "static/media/main_img_1.0a173ce5.png";